import PrivateListingLanding from './PrivateListingLanding.page';

export default PrivateListingLanding;
